import React from "react";
import { Badge } from "./ui/Badge";
import { Button } from "./ui/Button";
import { CheckCircle2 } from "lucide-react";
export function Hero() {
  return <section className="relative w-full bg-[#142FA8] pt-6 md:pt-10 pb-10 md:pb-16 overflow-hidden flex flex-col items-center" data-id="element-157" data-mp="ehtixvdhyzna">
      <div className="w-full max-w-[1180px] mx-auto px-4 md:px-5 flex flex-col items-center text-center" data-id="element-158" data-mp="4lqfmm6wsuyr">
        
        <Badge theme="dark" className="mb-3 md:mb-4" data-id="element-159" data-mp="12a0ljc9tg2v5">
          <span className="mr-1.5" data-id="element-160" data-mp="127eereur1rdz">⚙️</span> FORMACIÓN ELECTROMECÁNICA
        </Badge>
        
        <h1 className="text-[24px] sm:text-[30px] md:text-5xl lg:text-6xl font-[900] text-white tracking-[-1px] leading-[1] md:leading-[1.05] mb-3 md:mb-4 w-full max-w-4xl" data-id="element-161" data-mp="xb5qnbykqnuo">
          ESTA MISMA SEMANA PODÉS EMPEZAR A FORMARTE COMO <span className="text-[#FFC900]" data-id="element-162" data-mp="3d1ikzavvpeny">TÉCNICO ELECTROMECÁNICO</span>
        </h1>
        
        <p className="text-[14px] sm:text-[16px] text-white/95 mb-4 md:mb-6 max-w-[360px] md:max-w-2xl leading-[1.4] mx-auto" data-id="element-163" data-mp="3cz5w0drpe41e">
          Ampliá tus conocimientos y preparate para trabajos de mayor nivel técnico y nuevas oportunidades de generar ingresos.
        </p>

        <div className="w-[90%] sm:w-[100%] max-w-[360px] md:max-w-lg mx-auto mb-4 md:mb-6 relative flex justify-center" data-id="element-164" data-mp="3o73og9djvq70">
          <img src="https://cdn.magicpatterns.com/uploads/isVQq3rUyfWokQxcPikJvx/Diseno_sin_titulo.webp" alt="Mecánico Industrial PRO" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-165" data-mp="39cfotbutzlzb" />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3 mb-4 md:mb-6 w-full max-w-4xl" data-id="element-166" data-mp="30g6ozw2xylcn">
          {["Formación práctica", "10 bonos incluidos", "Certificado de finalización", "Acceso de por vida"].map((benefit, idx) => <div key={idx} className="flex items-center gap-2 bg-white/[0.055] py-2.5 px-3 md:py-3 md:px-4 rounded-xl border border-white/[0.09] min-h-[50px] md:min-h-[60px]" data-id="element-167" data-mp="2viewp0ydwx7x" data-mpi={idx}>
              <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-[#FFC900] flex-shrink-0" data-id="element-168" data-mp="2lkqyu25hf9lj" />
              <span className="text-[12px] sm:text-[14px] font-[600] text-white text-left leading-tight" data-id="element-169" data-mp="2lml8ulf7thau">{benefit}</span>
            </div>)}
        </div>

        <div className="flex flex-col items-center w-full" data-id="element-170" data-mp="na9yck53l6it">
          <Button size="xl" className="w-[90%] sm:w-[95%] max-w-[350px] mb-2" onClick={() => document.getElementById('oferta')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-171" data-mp="ibyrmia3nc4t">
            QUIERO ACCEDER AHORA <span className="ml-2 font-bold text-lg" data-id="element-172" data-mp="1b0vvvhhh78ek">→</span>
          </Button>
          <div className="flex items-center gap-1.5 text-[10px] sm:text-[11px] font-medium text-white/90" data-id="element-173" data-mp="1ayt8743sprd0">
            <span data-id="element-174" data-mp="15zzv3csf82dd">Acceso inmediato</span>
            <span data-id="element-175" data-mp="111yagnfcjuzs">•</span>
            <span data-id="element-176" data-mp="11150zep06rdy">Pago 100% seguro</span>
          </div>
        </div>
      </div>
    </section>;
}